import script from "./InputSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSelect.vue?vue&type=script&setup=true&lang=js"

import "./InputSelect.vue?vue&type=style&index=0&id=16f8ff6a&lang=css"

const __exports__ = script;

export default __exports__